// Last-seen copies of page data (per signed-in user) so screens can paint instantly, then refresh in the background.
const DB = "snaplist-cache", STORE = "kv", MAX_AGE = 7 * 864e5;
const mem = new Map();
let ns = "";
let dbp = null;

const idb = () => {
  if (!dbp) {
    dbp = new Promise((res) => {
      try {
        const r = indexedDB.open(DB, 1);
        r.onupgradeneeded = () => r.result.createObjectStore(STORE);
        r.onsuccess = () => res(r.result);
        r.onerror = () => res(null);
      } catch { res(null); }
    });
  }
  return dbp;
};
const tx = async (mode, fn) => {
  const db = await idb();
  if (!db) return null;
  return new Promise((res) => {
    try {
      const t = db.transaction(STORE, mode);
      const req = fn(t.objectStore(STORE));
      t.oncomplete = () => res(req?.result ?? null);
      t.onerror = () => res(null);
    } catch { res(null); }
  });
};

export const setCacheUser = (id) => { if (id !== ns) mem.clear(); ns = id || ""; };

// Any save/delete makes older copies unsafe to show; screens wait for fresh data until they've reloaded once.
let dirtyAt = 0;
export const BOOT_AT = Date.now();
const dirtySubs = new Set();
export const onDirty = (fn) => { dirtySubs.add(fn); return () => dirtySubs.delete(fn); };
export const markDirty = () => { dirtyAt = Date.now(); dirtySubs.forEach((f) => f()); };
export const dirtySince = (t) => dirtyAt > t;
// Newest change on the server (from /changes/latest); local copies remember which one they've seen.
let remote = "";
export const setRemoteChange = (iso) => { if (iso && iso > remote) remote = iso; };
export const remoteChange = () => remote;

// Returns { at, data } or null. any=true also returns copies made old by a save (used when there's no signal).
export async function readCache(key, any = false) {
  if (!ns) return null;
  const k = `${ns}|${key}`;
  const m = mem.get(k);
  if (m && (any || m.at > dirtyAt)) return m;
  if (m && !any) return null;
  const hit = await tx("readonly", (s) => s.get(k));
  if (!hit || Date.now() - hit.at > MAX_AGE || (!any && hit.at <= dirtyAt)) return null;
  mem.set(k, hit);
  return hit;
}

export function writeCache(key, data) {
  if (!ns) return;
  const v = { at: Date.now(), data };
  mem.set(`${ns}|${key}`, v);
  tx("readwrite", (s) => s.put(v, `${ns}|${key}`));
}

export function clearCache() {
  mem.clear();
  tx("readwrite", (s) => s.clear());
}

// Phone-side copies are downloaded at most once a day, plus whenever something changed (own saves or on the server).
export const copyStale = (st) => !st || Date.now() - (st.localAt || 0) > 864e5 || dirtySince(st.localAt) || (!!remote && remote > (st.seen || ""));
